import { ReactElement, ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { styles } from './auth-layout.styles';
import { ROUTES } from '../../../helpers/constans';
import xdosLogo from '../../../assets/img/xdos-logo.jpg';

interface IAuthLayoutProps {
  title: string;
  subtitle: string;
  children: ReactNode;
}

const AuthLayout = ({ title, subtitle, children }: IAuthLayoutProps): ReactElement => {
  return (
    <Box sx={styles.page} component="main">
      <Box sx={styles.brandPanel}>
        <Box
          sx={{
            ...styles.brandGlow,
            backgroundColor: '#2563EB',
            top: 48,
            right: -40,
          }}
        />
        <Box
          sx={{
            ...styles.brandGlow,
            backgroundColor: '#22C55E',
            bottom: 80,
            left: -30,
          }}
        />
        <Box sx={styles.brandHeader}>
          <Box component="img" src={xdosLogo} alt="" sx={styles.brandLogo} />
          <Typography sx={styles.brandName}>XDOS</Typography>
        </Box>
        <Box sx={styles.brandCopy}>
          <Typography sx={styles.brandEyebrow}>Digital Ownership</Typography>
          <Typography component="p" sx={styles.brandTitle}>
            Own, manage, and share digital objects with confidence.
          </Typography>
          <Typography sx={styles.brandSubtitle}>
            A secure workspace for organisations, teams, and events — built to keep every object
            identifiable, protected, and easy to use.
          </Typography>
        </Box>
        <Box sx={styles.brandPills} aria-hidden="true">
          <Box sx={styles.brandPill}>
            <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#22C55E' }} />
            Secure identity
          </Box>
          <Box sx={styles.brandPill}>
            <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#2563EB' }} />
            Event ready
          </Box>
          <Box sx={styles.brandPill}>
            <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#EF4444' }} />
            Team access
          </Box>
          <Box sx={styles.brandPill}>
            <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#FACC15' }} />
            Instant sharing
          </Box>
        </Box>
      </Box>

      <Box sx={styles.formPanel}>
        <Box sx={{ width: '100%', maxWidth: 580 }}>
          <Box sx={styles.mobileBrand}>
            <Box component="img" src={xdosLogo} alt="" sx={styles.mobileLogo} />
            <Typography sx={styles.mobileName}>XDOS</Typography>
          </Box>
          <Box sx={styles.card}>
            <Box component="img" src={xdosLogo} alt="XDOS logo" sx={styles.cardLogo} />
            <Typography component="h1" sx={styles.title}>
              {title}
            </Typography>
            <Typography sx={styles.subtitle}>{subtitle}</Typography>
            {children}
            <Box sx={styles.legal}>
              <Typography component={Link} to={ROUTES.terms} target="_blank" sx={styles.legalLink}>
                Terms
              </Typography>
              <Typography component={Link} to={ROUTES.privacy} target="_blank" sx={styles.legalLink}>
                Privacy
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AuthLayout;
